import React, {  useState } from "react";
import PropTypes from "prop-types";
import { red, grey } from "@mui/material/colors";
import { notification } from "../../../utils/Notifications";
import useLogout from '../../../hooks/auth/authHook.js';
import {
  Button,
  Container,
  Dialog,
  Typography,
  CircularProgress,
} from "@mui/material";

DeleteCategoryDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default function DeleteCategoryDialog({ onClose, open, fetchCategories, category }) {
  const [logout] = useLogout();

  const [isLoading, setIsLoading] = useState(false);

  const handleDeactivateCategoryClick = () => {
    if (isLoading) { return; }
    setIsLoading(true);

    /* deactivateCategory(category?.id_membership_type, !category?.is_active)
      .then((response) => {
        if (response.data.status_Code === 200) {
          notification({ text: "Categoría desactivada", type: "success" });
          fetchCategories();
          onClose();
        } else if (response.data.status_Code === 401) {
          notification({
            text: "Sesión expirada. Por favor, inicia sesión nuevamente.",
            type: "error",
          });
          setIsLoading(false);
          logout();
        } else {
          notification({
            text: "Error al desactivar la categoría",
            type: "error",
          });
          setIsLoading(false);
        }
      })
      .catch(() => {
        setIsLoading(false);
        notification({text: 'Error de conexión, revisa tu conexión a internet', type: 'error'});
      }); */
  };

  const buttonStyles = {
    width: "120px",
    borderRadius: "0.5rem",
    height: "38px",
  };

  const activeButtonStyles = {
    ...buttonStyles,
    backgroundColor: red["A400"],
    color: "white",
    "&:hover": {
      backgroundColor: red["A700"],
    },
  };

  const inactiveButtonStyles = {
    ...buttonStyles,
    backgroundColor: grey[500],
    color: grey[300],
  };

  const handleDialogClose = (event, reason) => {
    if (reason === "backdropClick") {
      // Evita cerrar el diálogo al hacer clic en el fondo
      return;
    }
    onClose();
  };

  return (
    <Dialog
      onClose={handleDialogClose}
      open={open}
      PaperProps={{ style: { borderRadius: "16px" } }}
    >
      <Container style={{ padding: 26 }}>
        <Typography
          component="div"
          variant="h5"
          style={{
            textAlign: "center",
            fontWeight: "bold",
            color: grey[800],
            marginBottom: 26,
          }}
        >
          Desactivar categoría
        </Typography>

        <Typography
          component="div"
          variant="body2"
          style={{
            textAlign: "center",
            color: grey[600],
            marginBottom: 26,
          }}
        >
          ¿Deseas desactivar la categoría <strong>"{category?.membership_name}"</strong>?
        </Typography>

        <Container
          style={{
            display: "flex",
            justifyContent: "end",
            width: "100%",
            padding: 0,
            marginTop: 36,
            gap: 12,
          }}
        >
          <Button
            variant="standard"
            color="primary"
            onClick={handleDialogClose}
            style={{
              width: "120px",
              borderRadius: "0.5rem",
              height: "38px",
              color: red["A400"],
              backgroundColor: red["50"],
            }}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            /* disabled={!isFormValid} */
            onClick={handleDeactivateCategoryClick}
            sx={true ? activeButtonStyles : inactiveButtonStyles}
          >
            {isLoading ? (
              <CircularProgress size={24} style={{ color: "white" }} />
            ) : (
              "Desactivar"
            )}
          </Button>
        </Container>
      </Container>
    </Dialog>
  );
}
